module.exports = __webpack_public_path__ + "static/media/eye_green_light.b917fca9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/eye_green_light.svg
// module id = 355
// module chunks = 0